import type { CSSProperties, Ref } from 'react';
import { NavLink } from 'react-router-dom';
import type { LiksMenuItem, LiksMenuPlacement } from './LiksMenu.types';

export type LiksMenuPanelProps = {
  panelRef: Ref<HTMLDivElement>;
  placement: LiksMenuPlacement;
  portalPanel: boolean;
  panelClassName?: string;
  panelStyle?: CSSProperties;
  items: LiksMenuItem[];
  itemClassName?: string;
  activeItemClassName?: string;
  onItemAction: (action?: () => void) => void;
};

export function LiksMenuPanel({
  panelRef,
  placement,
  portalPanel,
  panelClassName,
  panelStyle,
  items,
  itemClassName,
  activeItemClassName,
  onItemAction,
}: LiksMenuPanelProps) {
  return (
    <div
      ref={panelRef}
      className={[
        'liks-menu__panel',
        `liks-menu__panel--placement-${placement}`,
        portalPanel && 'liks-menu__panel--portaled',
        panelClassName,
      ]
        .filter(Boolean)
        .join(' ')}
      style={portalPanel ? panelStyle : undefined}
    >
      {items.map((item) => {
        if (item.type === 'link') {
          return (
            <NavLink
              key={item.id}
              to={item.to}
              className={({ isActive }) =>
                [
                  'liks-menu__item',
                  itemClassName,
                  item.className,
                  isActive && activeItemClassName,
                ]
                  .filter(Boolean)
                  .join(' ')
              }
              onClick={() => onItemAction(item.onClick)}
            >
              {item.icon}
              <span className="liks-menu__item-content">
                <span className="liks-menu__item-label">{item.label}</span>
                {item.description !== undefined && item.description !== '' && (
                  <span className="liks-menu__item-description">
                    {item.description}
                  </span>
                )}
              </span>
            </NavLink>
          );
        }

        return (
          <button
            key={item.id}
            type="button"
            className={['liks-menu__item', itemClassName, item.className]
              .filter(Boolean)
              .join(' ')}
            onClick={() => onItemAction(item.onClick)}
          >
            {item.icon}
            <span className="liks-menu__item-content">
              <span className="liks-menu__item-label">{item.label}</span>
              {item.description !== undefined && item.description !== '' && (
                <span className="liks-menu__item-description">
                  {item.description}
                </span>
              )}
            </span>
          </button>
        );
      })}
    </div>
  );
}
